/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext, useMemo } from 'react'

const EnvironmentContext = createContext<object>({})
export const useEnvironment = <T extends object>() => useContext(EnvironmentContext) as T

interface IEnvironment {
  env?: object
  extend?: boolean
}

const Environment = <T extends object>({ env = {}, extend = true, ...props }: IEnvironment) => {
  const environment = useEnvironment<T>()
  const newEnv = useMemo(
    () => (extend ? { ...environment, ...env } : env),
    [extend, environment, env]
  ) as T

  return (
    <EnvironmentContext.Provider
      value={newEnv}
      {...props}
    />
  )
}

export default Environment
